export * from "./permissions/mutations";

export const setAllAppsNumber = (state, data) => {
    state.appsNumber = data;
};

export const setPagedApps = (state, data) => {
    if (data.resetAppList) {
        state.pagedApps = data.data.apps;
    } else {
        state.pagedApps.push(...data.data.apps);
    }

    state.staticAppIdsList = data.data.ids;
    state.currentNrOfApps = data.data.appsNr;
    if (state.currentApp && state.currentApp.id && !state.currentApp.canManage) {
        const currentAppFromList = state.apps.filter(app => app.id === state.currentApp.id);
        if (currentAppFromList && currentAppFromList[0] && currentAppFromList[0].canManage) {
            [state.currentApp] = currentAppFromList;
        }
    }
};
export const setHasMore = (state, data) => {
    state.hasMore = data;
};

export const resetPagedApps = state => {
    state.pagedApps = [];
};

export const setLastPublish = (state, payload) => {
    state.currentApp.lastPublished = payload;
    sessionStorage.setItem("currentApp", JSON.stringify(state.currentApp));
};

export const setAllApps = (state, data) => {
    state.apps = data.data;
    if (state.currentApp && state.currentApp.id && !state.currentApp.canManage) {
        const currentAppFromList = state.apps.filter(app => app.id === state.currentApp.id);
        if (currentAppFromList && currentAppFromList[0] && currentAppFromList[0].canManage) {
            const { permission } = state.currentApp;
            [state.currentApp] = currentAppFromList;
            state.currentApp.permission = permission;
        }
    }
    state.appDDL = state.apps.map(app => ({
        label: app.name,
        value: app.id
    }));
};
export const updateCurrentAppStatus = (state, data) => {
    for (let i = 0; i < state.apps.length; i++) {
        if (state.apps[i].id === data.data.id) {
            state.apps[i].publishStatus = data.data.publishStatus;
            break;
        }
    }
};
export const setArchivingCurrentAppStatus = (state, data) => {
    for (let i = 0; i < state.pagedApps.length; i++) {
        if (state.pagedApps[i].id === data.data.id) {
            state.pagedApps[i].publishStatus = data.data.publishStatus;
            break;
        }
    }
};
export const updateCurrentAppInfo = (state, data) => {
    for (let i = 0; i < state.apps.length; i++) {
        if (state.apps[i].id === data.id) {
            state.apps[i].imageId = data.imageId;
            state.apps[i].imageUrl = data.imageUrl;
            state.apps[i].name = data.name;
            state.apps[i].description = data.description;
            state.apps[i].canManage = data.canManage;
            break;
        }
    }
};
export const addNewApp = (state, payload) => {
    state.apps.push(payload);
};
export const updatedApp = (state, data) => {
    state.updatedApp = data;
};
export const setCurrentApp = (state, payload) => {
    state.currentApp = payload;
    sessionStorage.setItem("currentApp", JSON.stringify(payload));
};
export const setCurrentProcess = (state, payload) => {
    state.currentProcess = payload;
    sessionStorage.setItem("currentProcess", JSON.stringify(payload));
};
export const updateCurrentApp = (state, payload) => {
    state.currentApp = { ...state.currentApp, ...payload };
};
export const setPath = (state, payload) => {
    state.path = payload;
};
export const setProcessList = (state, payload) => {
    state.processList = payload;
};
export const setAppWasArchived = (state, data) => {
    state.appWasArchived = data;
};

export const setDiagramExternalPlugins = (state, data) => {
    state.diagramExternalPluginList = data || {};
};
